import { createFileRoute } from '@tanstack/react-router';
import { RelatorioFinanceiroBalancete } from '@/features/relatorio/page/financeiro/balancete/RelatorioFinanceiroBalancete';

export const Route = createFileRoute('/a/relatorio/financeiro/balancete')({
    component: RelatorioFinanceiroBalancete,
});
